module.exports = __webpack_public_path__ + "img/alert_b1.2b76e871.gif";